import { render, staticRenderFns } from "./ExtratoAutorizacaoListagem.vue?vue&type=template&id=44ce94be&scoped=true"
import script from "./ExtratoAutorizacaoListagem.vue?vue&type=script&lang=js"
export * from "./ExtratoAutorizacaoListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ce94be",
  null
  
)

export default component.exports